export class DateCalc {
  public static daysBetween(firstDate: Date, secondDate: Date): number {
    const oneDayInMillis: number = 24 * 60 * 60 * 1000;
    const diffInMillis: number = firstDate.valueOf() - secondDate.valueOf();

    return Math.round(diffInMillis / oneDayInMillis);
  }
}